import React from "react";
import Account from "../components/Account";


const AccountPage = () => {



  return (
    <>
      <Account />
    </>
  );
};

export default AccountPage;
